var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.categories)?_c('Cascader',{ref:"categorySelect",attrs:{"disabled":_vm.disabled,"data":_vm.categories,"value":_vm.selectedValues,"trigger":"click","filterable":"","transfer":"","render-format":_vm.categoryFormat,"change-on-select":_vm.allowParentSelect,"placeholder":"Category"},on:{"on-change":_vm.handleSelectCategory}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }